import type { FaireProductEntity } from "../../entity_types/product";

export const p_g5vedkf494: FaireProductEntity = {
  token: "p_g5vedkf494",
  type: "product",
  name: "Be Your Own Best Friend",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/06f8460f7cbb0f98dbee7ed3bc55c5deeb13d795f7f15f6a6c097a880537aa7a.jpeg",
  galleryImageUrls: [],
  priceDollars: 9.5,
  description: "If life on both sides of fame has taught Ekin-Su anything, it's that the most important relationship you have is the one with yourself.\n\nIn this honest and uplifting guide to life, Ekin Su reveals the hard-won lessons that have made her the person she is today. Vulnerable, authentic, and packed with never heard before stories, readers will get to understand the woman behind the headlines and filters. It's time to get acquainted with the real Ekin-Su as she shares her story, in her own words.\n\nPowerful, inspiring and infused with the Ekin Su's trademark humour, warmth and honesty, Be Your Own Best Friend tells of overcoming childhood bullies, navigating difficult relationships - and how she is learning to love herself.",
  tags: [],
  msrpDollars: 18.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:56.915Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
